import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const WeatherSunOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function WeatherSunOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M12 7.5c2.48 0 4.5 2.02 4.5 4.5s-2.02 4.5-4.5 4.5-4.5-2.02-4.5-4.5S9.52 7.5 12 7.5Zm0-2a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM13 0h-2v3.5h2V0ZM13 20.5h-2V24h2v-3.5ZM24 11h-3.5v2H24v-2ZM3.5 11H0v2h3.5v-2ZM19.78 2.802l-2.474 2.475 1.414 1.414 2.475-2.474-1.414-1.415ZM5.28 17.308l-2.474 2.475 1.414 1.415 2.475-2.475-1.414-1.415ZM18.723 17.305 17.31 18.72l2.475 2.475 1.414-1.415-2.475-2.475ZM4.217 2.805 2.803 4.22l2.475 2.475L6.692 5.28 4.217 2.805Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default WeatherSunOutlined;